<!--
  What a lead sees instead of a locked view (see `leadRestriction.ts`): the
  demo request as a semi-dialog over the page area only. The app bar and the
  sidebar stay usable around it, the locked areas in it are what opens this.
  Behind it is a hint of a page, never the locked page itself.
-->
<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import GenericWrapper from '@/components/GenericWrapper.vue';
import LeadDemoRequest from '@/components/leadBot/LeadDemoRequest.vue';
import { lockedAreaTitleKey } from '@/components/leadBot/leadRestriction';
import { Skeleton } from '@/components/ui/skeleton';

const { t } = useI18n();
const route = useRoute();

const areaTitleKey = computed(() => lockedAreaTitleKey(route));
</script>

<template>
  <GenericWrapper>
    <div data-cy="lead-locked-view" class="relative flex flex-1 flex-col">
      <div aria-hidden="true" class="pointer-events-none absolute inset-0 overflow-hidden p-6 blur-[2px] select-none">
        <div v-if="areaTitleKey" class="mb-6 text-xl font-semibold text-primary">{{ t(areaTitleKey) }}</div>
        <div class="grid grid-cols-4 gap-4 max-md:grid-cols-2">
          <Skeleton v-for="n in 4" :key="n" class="h-24 animate-none" />
        </div>
        <Skeleton class="mt-6 h-72 animate-none" />
      </div>
      <div aria-hidden="true" class="absolute inset-0 bg-primary/40" />

      <!-- `my-auto` centers it while there's room, and keeps a taller one scrollable to its top -->
      <div class="relative flex flex-1 items-start justify-center overflow-y-auto px-4 py-10">
        <LeadDemoRequest :area-title-key="areaTitleKey" class="my-auto shrink-0" />
      </div>
    </div>
  </GenericWrapper>
</template>
